import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Chip } from '@mui/material';

interface NotificationUser {
  _id?: string;
  name?: string;
  email?: string;
  type?: string;
}

interface NotificationPanelProps {
  users: NotificationUser[];
}

export const NotificationPanel: React.FC<NotificationPanelProps> = ({ users }) => {
  return (
    <Box sx={{ p: 1.5 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        Notifications ({users.length})
      </Typography>
      {users.length > 0 ? (
        <List dense disablePadding>
          {users.map((u, i) => (
            <ListItem key={u._id || i} disablePadding sx={{ py: 0.25, display: 'flex', gap: 1 }}>
              <ListItemText
                primary={u.name || u.email || '—'}
                slotProps={{ primary: { variant: 'body2' } }}
              />
              {u.type && (
                <Chip
                  label={u.type}
                  size="small"
                  variant="outlined"
                  sx={{ height: 20, fontSize: '0.65rem' }}
                />
              )}
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2" color="text.secondary">No notifications configured.</Typography>
      )}
    </Box>
  );
};
